import { Helmet } from "react-helmet-async";

const SITE = "Les Sonneurs de la Côte";
const BASE = "https://les-sonneurs-de-la-cote.fr";

/** Titre, description et canonical propres à chaque page (visibles par Google qui exécute le JS). */
export default function Seo({ title, description, path = "/" }) {
  const fullTitle = title ? `${title} — ${SITE}` : `Cornemuses et bal trad à Calais — ${SITE}`;
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
}
